import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ResourcePopup = loadAsyncComponent(() => import('./Container'), 'popup');
